<template>
  <div class="fade-in">
    <div
      id="help-box"
      v-show="helpOpened"
      :class="{
        'slide-bottom-top': bottomTopAnimation,
        'slide-top-bottom': !bottomTopAnimation,
      }"
    >
      <div class="help-header">
        <h3>Dicas para enviar sua foto</h3>
        <div @click="closeHelp"><Icon name="close"/></div>
      </div>
      <div class="help-img">
        <Asset
          name="man-help.svg"
          alt="Homem segurando documento"
          title="Homem segurando documento"
        />
      </div>
      <div class="help-itens">
        <div class="help-item">
          <Icon name="document-help"/>
          <p>Deixe seu <b>rosto</b> e documento <b>visíveis</b> na imagem</p>
        </div>

        <div class="help-item">
          <Icon name="glasses-help"/>
          <p>
            <b>Retire boné, óculos</b> ou qualquer <b>acessório</b> que
            esteja utilizando
          </p>
        </div>

        <div class="help-item">
          <Icon name="sun-help"/>
          <p>
            Se possível, busque um <b>ambiente com boa iluminação</b> para que
            a foto saia bem nítida
          </p>
        </div>
      </div>
    </div>
    <Camera
      ref="v2-onboarding-selfie-camera"
      v-show="showCamera"
      headerText="Tire sua selfie"
      @sendImg="handleTakePicture"
      @openHelp="openHelp"
      :inSelfieStep="true"
      :canBackPage="false"
      :hideFooter="helpOpened"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Asset from '@/components/common/Asset.vue';
import Icon from '@/components/ui/AppIcon.vue';

import Camera from '../../onboarding/components/Camera.vue';

export default {
  name: 'onboarding-selfie-camera',
  components: { Camera, Asset, Icon },
  data: () => ({
    helpOpened: false,
    bottomTopAnimation: true,
    showCamera: true,
  }),
  methods: {
    ...mapActions('onboardingV2', ['sendImage', 'setLoading']),
    async handleTakePicture(base64Img) {
      await this.sendImage({
        base64Img,
        extraData: {
          selfieFlow: 'PARCELEX',
        },
      });
      this.setLoading({ loading: true });
      await this.handleNextStep();
      this.setLoading({ loading: false });
    },
    async handleNextStep() {
      this.$refs['v2-onboarding-selfie-camera'].closeCamera();
      await this.$router.replace({
        name: 'v2-onboarding-insurance',
        query: this.$route.query,
      });
    },
    openHelp() {
      this.helpOpened = !this.helpOpened;
      setTimeout(() => {
        this.showCamera = false;
      }, 500);
    },
    closeHelp() {
      this.showCamera = true;
      this.bottomTopAnimation = !this.bottomTopAnimation;
      setTimeout(() => {
        this.bottomTopAnimation = !this.bottomTopAnimation;
        this.helpOpened = !this.helpOpened;
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
  #help-box {
    position: absolute;
    height: 100vh;
    background: #fff;

    .help-header {
      display: flex;
      justify-content: space-between;

      margin: 20px 24px;
      height: 22px;
    }

    .help-img {
      img {
        width: 100%;
      }
    }

    .help-itens {
      margin: 28px 24px;

      .help-item {
        display: flex;
        align-items: center;

        margin-bottom: 32px;

        p {
          @extend .body-regular;
          margin-left: 16px;
        }

        img {
          width: 48px;
        }
      }
    }
  }

  @keyframes bottom-to-top {
    from {
      transform: translateY(200vh);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes top-to-bottom {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: translateY(200vh);
    }
  }

  .slide-bottom-top {
    animation-name: bottom-to-top;
    animation-duration: 500ms;
    animation-fill-mode: backwards;
  }

  .slide-top-bottom {
    animation-name: top-to-bottom;
    animation-duration: 500ms;
  }
</style>
